goog.provide("shadow.js.shim.module$src$svg$shapes$other$triangle_fill_right_svg$default");
shadow.js.shim.module$src$svg$shapes$other$triangle_fill_right_svg$default = shadow.js.shim.module$src$svg$shapes$other$triangle_fill_right_svg.default;
